// Action Types
export const actionTypes = {
	START_TIMER: 'START_TIMER',
	STOP_TIMER: 'STOP_TIMER',
	RESET_TIMER: 'RESET_TIMER',
	SET_TIMER_ELAPSED: 'SET_TIMER_ELAPSED',

	REGISTER_TIME: 'REGISTER_TIME',
	REGISTER_TIMES_BATCH: 'REGISTER_TIMES_BATCH',

	UNREGISTER_TIME: 'UNREGISTER_TIME',
	IMPORT_DATA: 'IMPORT_DATA',
	REGISTER_INFO: 'REGISTER_INFO',
	EDIT_REGISTER_TIME: 'EDIT_REGISTER_TIME',
	DEC_TIME: 'DEC_TIME',
	INC_TIME: 'INC_TIME',

	DNS: 'DNS',
	DISQUALIFY: 'DISQUALIFY',

	UPDATE_DISTANCE_OFFSET: 'UPDATE_DISTANCE_OFFSET',

	UPDATE_CATEGORY_OFFSET: 'UPDATE_CATEGORY_OFFSET'
};


// Action Creators
export const startTimer = (
	baseTime = 0
) => {

	return {
		type: actionTypes.START_TIMER,
		baseTime: baseTime,
		now: new Date().getTime()
	};
};

export const dns = (
	index = undefined,
	competition = 0
) => {

	return {
		type: actionTypes.DNS,
		now: new Date().getTime(),
		index: index,
		competition: competition
	};
};


export const registerInfo = (
	name = '',
	eventID = '',
	competition = 0,

	distance1Type = '',
	distance1Value = 0,
	distance1StartOffset = 0,

	distance2Type = '',
	distance2Value = 0,
	distance2StartOffset = 0,

	distance3Type = '',
	distance3Value = 0,
	distance3StartOffset = 0,

	showResultsDistance1 = false,
	showResultsLocales = false,
	date = '',
	place = '',
	sendSMS = false,
	beep = false,
	interval = 1,
	prefix = '',

	categoryStartOffsets = []
) => {

	return {
		type: actionTypes.REGISTER_INFO,

		name,
		eventID,
		competition,

		distance1Type,
		distance1Value,
		distance1StartOffset,

		distance2Type,
		distance2Value,
		distance2StartOffset,

		distance3Type,
		distance3Value,
		distance3StartOffset,

		showResultsDistance1,
		showResultsLocales,
		date,
		place,
		sendSMS,
		beep,
		interval,
		prefix,

		categoryStartOffsets:
			Array.isArray(
				categoryStartOffsets
			)
				? categoryStartOffsets
				: []
	};
};


export const editRegisterTime = (
	deltaTime = 0,
	time = "",
	index = undefined,
	partial = ""
) => {

	return {
		type: actionTypes.EDIT_REGISTER_TIME,
		now: time,
		index: index,
		partial: partial,
		deltaTime: deltaTime
	};
};


export const stopTimer = () => {

	return {
		type: actionTypes.STOP_TIMER,
		now: new Date().getTime()
	};
};

export const setTimerElapsed = (elapsedMs, now = Date.now()) => ({
	type: actionTypes.SET_TIMER_ELAPSED,
	elapsedMs,
	now
});


export const resetTimer = () => {

	return {
		type: actionTypes.RESET_TIMER,
		now: new Date().getTime()
	};
};


/*
 * Registro individual.
 *
 * Continúa siendo utilizado por:
 *
 * - Keyboard
 * - Touch
 * - registración real
 */
export const registerTime = (
	index = undefined,
	competition = 0,
	startOffset = 0
) => {

	const offsetMs =
		Number(
			startOffset || 0
		) *
		60 *
		1000;


	return {
		type: actionTypes.REGISTER_TIME,

		now:
			new Date().getTime() -
			offsetMs,

		index: index,

		competition: competition,

		startOffset:
			Number(
				startOffset || 0
			)
	};
};


/*
 * -------------------------------------------------------
 * REGISTRO MULTIPLE
 * -------------------------------------------------------
 *
 * Utilizado por Simulation.
 *
 * Permite registrar varios atletas
 * con UN SOLO dispatch Redux.
 *
 * arrivals tendrá esta estructura:
 *
 * [
 *     {
 *         index: 10,
 *         now: 1780000000000
 *     },
 *     {
 *         index: 25,
 *         now: 1780000000250
 *     }
 * ]
 *
 * Cada atleta puede conservar su tiempo
 * individual aunque todos se actualicen
 * dentro del mismo batch.
 */
export const registerTimesBatch = (
	arrivals = [],
	competition = 0,
	replaceExisting = false
) => {

	return {
		type:
			actionTypes.REGISTER_TIMES_BATCH,

		arrivals:
			Array.isArray(arrivals)
				? arrivals
				: [],

		competition:
			competition,

		replaceExisting:
			Boolean(
				replaceExisting
			)
	};
};


export const disqualify = (
	index = undefined,
	competition = 0
) => {

	return {
		type: actionTypes.DISQUALIFY,
		now: new Date().getTime(),
		index: index,
		competition: competition
	};
};


export const incTime = (
	time = 0,
	index = undefined,
	competition = 0
) => {

	return {
		type: actionTypes.INC_TIME,
		now: time,
		index: index,
		competition: competition
	};
};


export const decTime = (
	time = 0,
	index = undefined,
	competition = 0
) => {

	return {
		type: actionTypes.DEC_TIME,
		now: time,
		index: index,
		competition: competition
	};
};


export const unRegisterTime = (
	index = undefined,
	competition = 0
) => {

	return {
		type: actionTypes.UNREGISTER_TIME,
		now: 0,
		index: index,
		competition: competition
	};
};


export const importData = (
	participantList = [],
	infoList = [],
	catStats = [],
	gralStats = []
) => {

	console.log(
		participantList,
		infoList,
		catStats,
		gralStats
	);


	return {
		type: actionTypes.IMPORT_DATA,
		participantList: participantList,
		infoList: infoList,
		catStats: catStats,
		gralStats: gralStats
	};
};


/*
 * Recalibra los tiempos ya registrados
 * cuando cambia el offset de una distancia.
 *
 * distance:
 * distancia afectada, por ejemplo "14"
 *
 * deltaMinutes:
 * diferencia entre offset nuevo y anterior
 *
 * Ejemplo:
 *
 * anterior = 2
 * nuevo    = 4
 * delta    = 2
 *
 * Los atletas de esa distancia deben tener
 * 2 minutos MENOS en su tiempo registrado.
 */
export const updateDistanceOffset = (
	distance = '',
	deltaMinutes = 0
) => {

	return {
		type:
			actionTypes.UPDATE_DISTANCE_OFFSET,

		distance:
			String(
				distance
			),

		deltaMinutes:
			Number(
				deltaMinutes || 0
			)
	};
};


/*
 * Recalibra los tiempos ya registrados
 * cuando cambia el offset de una categoría.
 *
 * Utilizado por:
 *
 * - Triatlón
 * - Duatlón
 * - Rural Bike / MTB
 *
 * catCod:
 * código de categoría del participante.
 *
 * Ejemplo:
 *
 * "CAB PRO"
 *
 * deltaMinutes:
 * diferencia entre offset nuevo y anterior.
 *
 * Ejemplo:
 *
 * anterior = 2
 * nuevo    = 4
 * delta    = 2
 *
 * Los atletas de esa categoría deben tener
 * 2 minutos MENOS en su tiempo registrado.
 */
export const updateCategoryOffset = (
	catCod = '',
	deltaMinutes = 0
) => {

	return {
		type:
			actionTypes.UPDATE_CATEGORY_OFFSET,

		catCod:
			String(
				catCod || ''
			).trim(),

		deltaMinutes:
			Number(
				deltaMinutes || 0
			)
	};
};



// WEBPACK FOOTER //
// ./src/actions/index.js